<template>
    <div class="hello">
        <h1>aa</h1>
    </div>
</template>

<script>
export default {
    name: "aaa",
    mounted() {
        this.$vuex("vuex_token", "aa11111a");
        console.log(this.vuex_token);
        this.$vuex("vuex_version", "");
    },
};
</script>

<style scoped>
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
